<template>
  <header class="hero-section">
    <nav class="top-nav">
      <router-link to="/" class="nav-brand">thedawie</router-link>
      <div class="nav-links">
        <router-link to="/" class="nav-link" :class="{ 'active': $route.path === '/' }">
          Posts
        </router-link>
        <router-link to="/cv" class="nav-link" :class="{ 'active': $route.path === '/cv' }">
          CV / Resume
        </router-link>
      </div>
    </nav>

    <div class="hero-content">
      <p class="hero-subtitle">HELLO PEOPLE, MY NAME IS</p>
      <h1 class="hero-title">David</h1>
      <p class="hero-ticker">{{ tickerText }}</p>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const tickerText = ref('32okli');
let tickerInterval = null;

onMounted(() => {
  tickerInterval = setInterval(() => {
    tickerText.value = Math.random().toString(36).substring(7);
  }, 1000);
});

onUnmounted(() => {
  if (tickerInterval) {
    clearInterval(tickerInterval);
    tickerInterval = null;
  }
});
</script>

<style scoped>
.hero-section {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 999px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.nav-brand {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--text-white);
  transition: opacity 0.2s ease;
}

.nav-brand:hover {
  opacity: 0.8;
}

.nav-links {
  display: flex;
  gap: 16px;
  align-items: center;
}

.nav-link {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-white-dim);
  padding: 6px 14px;
  border-radius: 999px;
  transition: all 0.2s ease;
}

.nav-link:hover {
  color: var(--text-white);
  background: rgba(255, 255, 255, 0.08);
}

.nav-link.active {
  color: var(--text-white);
  background: rgba(255, 255, 255, 0.15);
}

.hero-content {
  text-align: center;
  padding: 20px 0 10px;
}

.hero-subtitle {
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 4px;
  color: #d1d5db;
  margin-bottom: 12px;
  text-transform: uppercase;
}

.hero-title {
  font-size: 3.8rem;
  font-weight: 700;
  color: var(--text-white);
  line-height: 1.1;
  margin-bottom: 14px;
  letter-spacing: -0.5px;
}

.hero-ticker {
  font-size: 1.25rem;
  color: #9ca3af;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
  letter-spacing: 2px;
  height: 28px;
}

@media (max-width: 640px) {
  .top-nav {
    padding: 10px 16px;
    margin-bottom: 30px;
  }
  .hero-title {
    font-size: 2.8rem;
  }
  .hero-subtitle {
    font-size: 0.8rem;
    letter-spacing: 3px;
  }
}
</style>
